var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonChartTemplate',{attrs:{"datasets":_vm.datasetsFields,"full-screen-mode":"","loading":_vm.loading,"tooltip-formatter":_vm.tooltipFormatter,"legend-options":_vm.legendOptions,"x-labels":_vm.xLabels}})}
var staticRenderFns = []

export { render, staticRenderFns }